import { toTask } from '@execonline-inc/maybe-adapter';
import { URLParser, putQueryParam, toUrlT } from '@execonline-inc/url';
import { Maybe } from 'maybeasy';
import { Task } from 'taskarian';
import { callApi } from '../../../../../Appy';
import { Link } from '../../../../../Resource/Types';
import { setFilteredState, warnAndSetErrorState } from './Actions';
import { filterOptionsResourceDecoder } from './Decoder';
import {
  FilterError,
  FilterOption,
  Filtering,
  Loading,
  NewState,
  ParticipantAndGroupOptionResource,
  initialValueMissing,
  ready,
} from './Types';

const urlTask = (endpoint: Link, state: Filtering): Task<FilterError, Link> =>
  toUrlT(endpoint.href)
    .map(putQueryParam(`filter[query]`, state.filterBy))
    .map(linkConstructor(endpoint));

const linkConstructor = (endpoint: Link) => (url: URLParser) => ({
  rel: endpoint.rel,
  href: url.href,
  method: endpoint.method,
  type: endpoint.type,
});

const buildLink =
  (endpoint: Link) =>
  (v: ParticipantAndGroupOptionResource): Task<FilterError, Link> =>
    toUrlT(endpoint.href)
      .map(putQueryParam(`filter[id]`, v.payload.value))
      .map(linkConstructor(endpoint));

export const fetchOptions = (
  endpoint: Link,
  state: Filtering,
  setState: (value: NewState) => void,
) =>
  urlTask(endpoint, state)
    .andThen(callApi(filterOptionsResourceDecoder, {}))
    .fork(warnAndSetErrorState(setState), setFilteredState(state, setState));

export const loadOptions = (
  initialValue: Maybe<FilterOption>,
  endpoint: Link,
  setState: (value: NewState) => void,
  state: Loading,
) =>
  Task.succeed<FilterError, Maybe<FilterOption>>(initialValue)
    .andThen(toTask(initialValueMissing()))
    .andThen(buildLink(endpoint))
    .andThen(callApi(filterOptionsResourceDecoder, {}))
    .fork(() => setState(ready()), setFilteredState(state, setState));
